import React from 'react';
import { useConfig } from '../context/ConfigContext';

const Header = ({ showBrain = true, title, subtitle }) => {
    const { config } = useConfig();

    // Config values or defaults
    const logo_tittle = config?.logo_tittle || 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Logo_4toNeuroUpdate.png';
    const brainImage = config?.brainImage || 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Imagen_KV_Suelta.png';

    // Extreme neon style applied directly to images
    const neonStyle = {
        filter: 'drop-shadow(0 0 200px #29032eff) drop-shadow(0 0 30px #3d0845ff) drop-shadow(0 0 45px rgba(79, 6, 87, 0.82))'
    };

    return (
        <header className="pt-6 sm:pt-10 pb-4 relative z-15 flex flex-col items-center w-full overflow-visible">
            <div className="relative w-full max-w-4xl px-4 flex flex-col items-center overflow-visible">
                {/* Header Container with relative overflow handling */}
                <div className="relative w-full flex items-center justify-center min-h-[120px] sm:min-h-[220px] overflow-visible">

                    {/* Brain Visual (KV) - Responsive positioning */}
                    {showBrain && (
                        <div
                            className="absolute top-[70%] left-1/2 -translate-x-[105%] -translate-y-[62%] sm:-translate-x-[125%] sm:-translate-y-[55%] 
                                        w-[250px] h-[250px] sm:w-[420px] sm:h-[420px] opacity-100 pointer-events-none select-none z-0 transition-all duration-700"
                        >
                            <img
                                src={brainImage}
                                alt="Brain"
                                className="w-full h-full object-contain"
                                //style={neonStyle}
                                loading="lazy"
                            />
                        </div>
                    )}

                    {/* Logo Section */}
                    <div
                        className="relative z-10 max-w-[180px] sm:max-w-[300px] transition-all duration-500 transform translate-x-20"
                    >
                        {logo_tittle ? (
                            <img
                                src={logo_tittle}
                                alt="NeuroUpdate Logo"
                                className="w-full h-auto"
                                style={neonStyle}
                                loading="eager"
                            />
                        ) : (
                            <div className="text-center" style={neonStyle}>
                                <h1 className="text-3xl sm:text-5xl font-black text-white italic uppercase tracking-tighter">NeuroUpdate</h1>
                                <p className="text-[10px] sm:text-xs font-bold text-white uppercase tracking-[0.4em] mt-2 italic">LATAM 2026</p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Page Title & Subtitle */}
                {(title || subtitle) && (
                    <div className="mt-4 sm:mt-6 text-center animate-fadeInUp">
                        {title && (
                            <h2 className="text-4xl sm:text-6xl font-black text-white italic uppercase tracking-tighter drop-shadow-2xl">
                                {title}
                            </h2>
                        )}
                        {subtitle && (
                            <div className="inline-block mt-1 px-4 py-1 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
                                <p className="text-[10px] sm:text-xs font-black text-white uppercase tracking-[0.3em]">
                                    {subtitle}
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
